<template>
  <div>
    <v-data-table
      dense
      multi-sort
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-btn rounded small @click="refresh" color="accent">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-divider vertical class="mx-4" inset></v-divider>
        </v-toolbar>
      </template>
      <template v-slot:item._id="{ item }">
        <span style="display: inline-block; width: 50px" class="text-truncate" :title="item._id">
          {{ item._id }}
        </span>
      </template>
      <template v-slot:item.user_id="{ item }">
        {{ item.user_id ? item.user_id.firstName : 'N/A' }} {{ item.user_id ? item.user_id.lastName : 'N/A' }}
      </template>
      <template v-slot:item.url="{ item }">
        <a :href="SERVER_URL + item.url" download target="_blank" class="text-decoration-none">
          <v-icon color="primary">mdi-download</v-icon>
        </a>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ (new Date(item.createdAt)).toLocaleString('ro-RO') }}
      </template>
      <template v-slot:item.updatedAt="{ item }">
        {{ (new Date(item.updatedAt)).toLocaleString('ro-RO') }}
      </template>
      <template v-slot:item.document="{ item }">
        {{ item.document ? documentTypes[item.document] : 'nedefinit' }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import SERVER_URL from '@/config'

export default {
  name: 'UsersApplicationsComponent',

  data: () => ({
    SERVER_URL,
    headers: [
      {
        text: 'id',
        value: '_id',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'depus de',
        value: 'user_id',
        align: 'left',
        sortable: false,
        filterable: false
      },
      // {
      //   text: 'denumire',
      //   value: 'title',
      //   align: 'left',
      //   sortable: true,
      //   filterable: true
      // },
      // {
      //   text: 'descriere',
      //   value: 'description',
      //   align: 'left',
      //   sortable: true,
      //   filterable: true
      // },
      {
        text: 'data',
        value: 'createdAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'tip',
        value: 'type',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'document',
        value: 'document',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'link',
        value: 'url',
        align: 'start',
        sortable: false,
        filterable: false
      }
    ],
    documentTypes: Object.freeze({
      1: '1. Cerere-tip de înscriere Dosar plan de afaceri (format PDF)',
      2: '2. Declarația de eligibilitate participant (format PDF)',
      3: '3. Certificat/Adeverință de absolvire a unui program de formare antreprenorială specifică economiei sociale (format PDF)',
      4: '4. Declarația-angajament de respectare a termenilor și condițiilor concursului planurilor de afaceri (format PDF)',
      5: '5. Planul de afaceri format Word editabil',
      6: '6. Planul de afaceri format PDF',
      7: '7. Bugetul format Excel editabil',
      8: '8. Bugetul format PDF',
      9: '9. Grafic Gantt de implementare activități format editabil (Excel sau Word)',
      10: '10. Grafic Gantt de implementare activități format PDF',
      11: '11. Fișele de post format Word',
      12: '12. Fișele de post format PDF',
      13: '13. Documente personale în format PDF (aici se vor încărca toate Documentele personale format PDF, conform Metodologiei. Pot fi încărcate mai multe documente separate)'
    })
  }),

  computed: {
    items () {
      return this.$store.getters.filesItems
    },
    options: {
      get () {
        return this.$store.getters.filesOptions
      },
      set (value) {
        this.$store.dispatch('setFilesOptions', value)
      }
    },
    totalItems () {
      return this.$store.getters.filesTotal
    },
    loading () {
      return this.$store.getters.filesLoading
    }
  },

  methods: {
    refresh () {
      this.$store.dispatch('fetchFiles')
    }
  }
}
</script>
